import * as React from "react";
import { createUseStyles } from "react-jss";
import { getTheme } from "@warda/library-ui/theme";
import Text from "@warda/library-ui/core/Text";
import Toolbar from "@warda/library-ui/core/Toolbar";
import Switch from "@warda/library-ui/core/Switch";
import InputSearch from "@warda/library-ui/core/InputSearch";
import MenuFiltersValued from "./MenuFiltersValued";
import BtnManager from "./BtnManager";
import SelectCond from "./SelectCond";
import { FILTERS_STICKY } from "../AreaProducts/constants";
import { getActiveFilters, getFilterSetData, FilterTypeCategory, setSlcSaveValues, } from "./utils";
import { onUpdateSet } from "../../api/fetchesApiJsonStore";
import getMngSetsSelected from "../../utils/getMngSetsSelected";
import { updateMngLevels } from "../AreaProducts/getMngLevels";
import { AggregateTypePrefKeySuffix } from "../../constants/userpref";
import { useContextAggrType, useContextUserPref } from "../Main";
import buildAggregateTypePrefKey from "../AreaProducts/utils/buildAggregateTypePrefKey";
import ScopeSwitch from "./ScopeSwitch/ScopeSwitch";
const useStyles = createUseStyles({
    scopeToolbar: {
        paddingBottom: "10px",
        justifyContent: "center",
        height: 30,
        minHeight: 30,
    },
});
const PanelFiltersTitle = ({ filters, onFiltersChange, menuValuedOpen, onMenuAppliedOpen, mngSets, mngSetsOpen, mngSetsContext, mngSetsOnError, mngSetsOnChange, mngLevels, slcCondVisible, slcCond, onSlcCondChange, searchScope, onSearchScopeChange, searchScopeEnabled = false, slcSave, slcSaveVisible, enableShared, enableLevels, enableSearch, onSearchInput, searchInput, }) => {
    var _a;
    const userPref = useContextUserPref();
    const classes = useStyles();
    const aggregateType = useContextAggrType().value;
    const filtersAttribute = filters
        .filter((f) => !FILTERS_STICKY.has(f.id))
        .filter((f) => f.type !== FilterTypeCategory);
    const filtersAttributeSet = new Set(filtersAttribute.map((f) => f.id));
    const filtersOthers = filters.filter((f) => !filtersAttributeSet.has(f.id));
    const onFilterClean = React.useCallback((filtersClean) => {
        onFiltersChange([].concat(filtersOthers, filtersClean));
    }, [filtersOthers, onFiltersChange]);
    const filtersSeteLevelsPrefKey = buildAggregateTypePrefKey({
        aggregateType,
        suffix: AggregateTypePrefKeySuffix.filtersSetLevels,
    });
    const mngLevelsFilters = ((_a = userPref[filtersSeteLevelsPrefKey]) !== null && _a !== void 0 ? _a : []);
    const levels = updateMngLevels(mngLevels, mngLevelsFilters);
    const filtersRendered = getActiveFilters({
        preferences: userPref,
        context: mngSetsContext,
        mngSets,
        filters,
    });
    const onSlcSaveChange = React.useCallback((b) => {
        setSlcSaveValues(b);
        const { slcSetId, slcSet } = getMngSetsSelected(mngSetsContext, userPref, mngSets);
        if (!!slcSetId) {
            const newSet = {
                ...slcSet,
                payload: {
                    ...slcSet.payload,
                    items: slcSet.payload.items.map((s) => {
                        const filter = filters.find((f) => f.id === s.id);
                        return getFilterSetData(filter, b);
                    }),
                },
            };
            const newSets = mngSets.map((s) => {
                if (s.id !== slcSetId)
                    return s;
                return newSet;
            });
            onUpdateSet(mngSetsContext, newSet);
            mngSetsOnChange({
                context: mngSetsContext,
                slcId: slcSetId,
                newId: false,
                sets: newSets,
                keepValue: b,
                updateFilters: false,
            });
        }
    }, [filters, mngSets, mngSetsContext, mngSetsOnChange, userPref]);
    if (!filters.length)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Toolbar, null,
            React.createElement(Text, { weight: "bolder", style: { marginRight: 5 }, children: "Filters" }),
            React.createElement(MenuFiltersValued, { filters: filtersAttribute, onFiltersChange: onFilterClean, open: menuValuedOpen, setOpen: onMenuAppliedOpen }),
            React.createElement("div", { style: { flex: 1 } }),
            !slcSaveVisible || !filtersRendered.length || !mngSets ? null : (React.createElement(Switch, { style: { marginRight: 5 }, checked: slcSave, color: getTheme().colors.theme1, tooltip: "Apply current filters' value on next page access", icon: "save", onChange: onSlcSaveChange })),
            !filtersRendered.length || !slcCondVisible ? null : (React.createElement(SelectCond, { style: { marginRight: 10 }, value: slcCond, onChange: onSlcCondChange })),
            !mngSets ? null : (React.createElement(BtnManager, { open: mngSetsOpen, filters: filtersAttribute, mngSets: mngSets, context: mngSetsContext, onError: mngSetsOnError, onChange: mngSetsOnChange, levels: levels, enableShared: enableShared, enableLevels: enableLevels })),
            !enableSearch ? null : (React.createElement(InputSearch, { style: { width: 150 }, value: searchInput, onChange: onSearchInput, placeholder: "Search filters..." }))),
        !searchScopeEnabled ||
            !filtersRendered.length ||
            !onSearchScopeChange ? null : (React.createElement(Toolbar, { className: classes.scopeToolbar },
            React.createElement(ScopeSwitch, { onChange: onSearchScopeChange, value: searchScope })))));
};
export default PanelFiltersTitle;
